import { StatusType } from '../../../../global/types';
import { CollectStatus } from './types';

export const PARTNER_SOURCES = ['glovo_user', 'wolt_user'];

const IS_DEV_AREA = Boolean(process.env.REACT_APP_DEV_AREA);
export const COLLECT_SOURCE_TAG_ID = IS_DEV_AREA ? 1049 : 1195;
export const COLLECT_NETWORK_TAG_ID = IS_DEV_AREA ? 1050 : 1196;

export const PARTNER_NAMES: Record<string, string> = {
  glovo_user: 'Glovo',
  wolt_user: 'Wolt',
};

export const PARTNER_SUPPORT_PHONES: Record<string, string> = {
  glovo_user: '+77273574580',
};

// Статусы аптеки, в которых фармацевт ещё может менять состав заказа
export const COLLECT_EDITABLE_STATUSES: string[] = [
  StatusType.NEW,
  StatusType.IN_PHARMACY_PLACED,
  StatusType.WAITING_RECEIPT,
  StatusType.IN_PHARMACY_COLLECTING,
  StatusType.IN_PHARMACY_COLLECTED,
];

export interface CollectStatusConfig {
  labelKey: string;
  fullLabelKey: string;
  icon: string;
  color: string;
  background: string;
  border: string;
}

export const COLLECT_STATUS_CONFIG: Record<CollectStatus, CollectStatusConfig> =
  {
    [CollectStatus.IN_STOCK]: {
      labelKey: 'OrderPage.Collect.Status.IN_STOCK',
      fullLabelKey: 'OrderPage.Collect.StatusLabel.IN_STOCK',
      icon: '✅',
      color: '#1fa069',
      background: '#f0fdf4',
      border: '#bbf7d0',
    },
    [CollectStatus.OUT_OF_STOCK]: {
      labelKey: 'OrderPage.Collect.Status.OUT_OF_STOCK',
      fullLabelKey: 'OrderPage.Collect.StatusLabel.OUT_OF_STOCK',
      icon: '🚫',
      color: '#eb5757',
      background: '#fef2f2',
      border: '#fecaca',
    },
    [CollectStatus.LESS]: {
      labelKey: 'OrderPage.Collect.Status.LESS',
      fullLabelKey: 'OrderPage.Collect.StatusLabel.LESS',
      icon: '🔢',
      color: '#ea580c',
      background: '#fff7ed',
      border: '#fed7aa',
    },
    [CollectStatus.EXPIRY]: {
      labelKey: 'OrderPage.Collect.Status.EXPIRY',
      fullLabelKey: 'OrderPage.Collect.StatusLabel.EXPIRY',
      icon: '📅',
      color: '#b18500',
      background: '#fefce8',
      border: '#fef08a',
    },
    [CollectStatus.DEFECT]: {
      labelKey: 'OrderPage.Collect.Status.DEFECT',
      fullLabelKey: 'OrderPage.Collect.StatusLabel.DEFECT',
      icon: '⚠️',
      color: '#8c3aaa',
      background: '#faf5ff',
      border: '#e9d5ff',
    },
    [CollectStatus.OTHER_PRICE]: {
      labelKey: 'OrderPage.Collect.Status.OTHER_PRICE',
      fullLabelKey: 'OrderPage.Collect.StatusLabel.OTHER_PRICE',
      icon: '🏷️',
      color: '#0a77c7',
      background: '#eff6ff',
      border: '#bfdbfe',
    },
  };

export const DEFECT_REASON_KEYS = [
  'DAMAGED_PACKAGE',
  'OPENED_PACKAGE',
  'BROKEN',
  'OTHER',
];

export const EXP_DATE_PATTERN = /^(0[1-9]|1[0-2])\.\d{4}$/;
